import { makeCRUDSlice } from '@redux/crudCreator';
import {
  MODEL_NAME,
  ordersReturnActions,
} from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersReturnActions)

export default slice.reducer;
